import React from 'react';
import { Button, IconButton } from '@mui/material';
import { MdClose } from 'react-icons/md';
import Swal from 'sweetalert2';

const SummaryModal = ({
  isOpen, 
  onClose, 
  summaryData, 
  currentPage,
  itemsPerPage,
  
  onFirstPage,
  onLastPage,
  onPrevPage,
  onNextPage,
  loading = false // Add loading prop
}) => {
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = summaryData.slice(indexOfFirstItem, indexOfLastItem);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="row justify-content-between align-items-center mb-3">
          <div className="col-auto">
            <h5 className="mt-4">Summary</h5>
          </div>
          <div className="col-auto">
            <IconButton onClick={onClose} size="small">
              <MdClose />
            </IconButton>
          </div>
        </div>
        <div className="table-responsive">
          {loading ? (
            <div className="text-center py-5">
              <p className="mt-2">Loading summary data...</p>
            </div>
          ) : (
            <table className="table table-bordered table-striped">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>File Type</th>
                  <th>File Name</th>
                  <th>Scenario</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((row, index) => (
                  <tr key={row.id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{row.file_type}</td>
                    <td>{row.output_filename}</td>
                    <td>{row.scenario}</td>
                    <td>{row.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {!loading && (
          <div className="d-flex justify-content-end mt-3">
            <div className="pagination">
              <Button
                variant="outlined"
                size="small"
                onClick={onFirstPage}
                disabled={currentPage === 1}
                className="me-2"
              >
                First
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={onPrevPage}
                disabled={currentPage === 1}
                className="me-2"
              >
                Prev
              </Button>
              <span className="mx-2 align-self-center">
                Page {currentPage} of {Math.ceil(summaryData.length / itemsPerPage)}
              </span>
              <Button
                variant="outlined"
                size="small"
                onClick={onNextPage}
                disabled={summaryData.length === 0 || currentPage === Math.ceil(summaryData.length / itemsPerPage)}
                className="me-2"
              >
                Next
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={onLastPage}
                disabled={summaryData.length === 0 || currentPage === Math.ceil(summaryData.length / itemsPerPage)}
              >
                Last
              </Button>
            </div>
          </div>
        )}
                  <div className="d-flex justify-content-end mt-3">
            <button className="btn createButton" onClick={onClose}>
              Close
            </button>
          </div>
      </div>
    </div>
  );
};

export default SummaryModal;
